import { render } from "./BulkEmailView.vue?vue&type=template&id=847c0214&ts=true"
import script from "./BulkEmailView.vue?vue&type=script&lang=ts"
export * from "./BulkEmailView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__